import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import FormFieldsTable from "./FormFieldsTable";
import ActionButton from "../ActionButton";
import TextInputField from "./TextInputField";
import FormError from "./FormError";
import DropDownInputField from "./DropDownInputField";

class ConfirmWithReasonForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting, options = null} = this.props;
    let submitLabel = submitting ? "Standby..." : "Confirm";

    const fieldOptions = {
      component: TextInputField,
    }
    if (options) {
      fieldOptions.component = DropDownInputField;
      fieldOptions.data = options;
      fieldOptions.valueKey = "id";
      fieldOptions.titleKey = "title";
    }
      
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          {this.props.children}
          <FormFieldsTable>
            <Field 
              label="Reason"
              name="reason"
              serverError={this.props.errors.reason}
              {...fieldOptions}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "ConfirmWithReasonForm"
})(ConfirmWithReasonForm);

ReduxForm.defaultProps = {
  message: "Confirm message"
}

export default ReduxForm;